import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_4c48524a from 'nuxt_plugin_plugin_4c48524a' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_nuxtplugin41788880_6c9658a9 from 'nuxt_plugin_nuxtplugin41788880_6c9658a9' // Source: ./nuxt.plugin.41788880.js (mode: 'server')
import nuxt_plugin_vuescrollto_41079bc0 from 'nuxt_plugin_vuescrollto_41079bc0' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_c5e9c51e from 'nuxt_plugin_cookieuniversalnuxt_c5e9c51e' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_0de4a992 from 'nuxt_plugin_pluginutils_0de4a992' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginseo_7585d966 from 'nuxt_plugin_pluginseo_7585d966' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_453dcb46 from 'nuxt_plugin_pluginrouting_453dcb46' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_1277939c from 'nuxt_plugin_pluginmain_1277939c' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_gtm_d0c75642 from 'nuxt_plugin_gtm_d0c75642' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_distplugin906f0602_832a181c from 'nuxt_plugin_distplugin906f0602_832a181c' // Source: ./dist.plugin.906f0602.mjs (mode: 'all')
import nuxt_plugin_image_6df72cc4 from 'nuxt_plugin_image_6df72cc4' // Source: ./image.js (mode: 'all')
import nuxt_plugin_coreplugin5c3f1c1c_9aa8fe18 from 'nuxt_plugin_coreplugin5c3f1c1c_9aa8fe18' // Source: ./core.plugin.5c3f1c1c.ts (mode: 'all')
import nuxt_plugin_pluginse2etesting371dcffc_58d937d2 from 'nuxt_plugin_pluginse2etesting371dcffc_58d937d2' // Source: ./plugins.e2e-testing.371dcffc.js (mode: 'all')
import nuxt_plugin_deviceplugin_bcb82358 from 'nuxt_plugin_deviceplugin_bcb82358' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_workbox_0973d6a5 from 'nuxt_plugin_workbox_0973d6a5' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_6cb2a8b8 from 'nuxt_plugin_metaplugin_6cb2a8b8' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_tokenexpired_ca1e20ca from 'nuxt_plugin_tokenexpired_ca1e20ca' // Source: ../plugins/token-expired (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_fcPlugin_5a846bc6 from 'nuxt_plugin_fcPlugin_5a846bc6' // Source: ../plugins/fcPlugin (mode: 'all')
import nuxt_plugin_dompurify_9e093c4a from 'nuxt_plugin_dompurify_9e093c4a' // Source: ../plugins/dompurify (mode: 'all')
import nuxt_plugin_storeConfigPlugin_234467e0 from 'nuxt_plugin_storeConfigPlugin_234467e0' // Source: ../plugins/storeConfigPlugin (mode: 'all')
import nuxt_plugin_meta_4a1ca6a6 from 'nuxt_plugin_meta_4a1ca6a6' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Espacial Suprimentos","meta":[{"charset":"utf8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Sempre em seu Escritório"},{"name":"google-site-verification","content":"MOnsMSVWFMlJ5n793bZfJ26PQ4w74ifhOSCBjENfqmw"},{"name":"generator","content":"Vue Storefront 2"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com","crossorigin":"anonymous"},{"rel":"preload","href":"\u002F\u002Fbanners\u002Fcarousel\u002Fdesktop\u002Fbanner_1_21-05-2025.webp","as":"image"},{"rel":"preload","href":"\u002F\u002Fbanners\u002Fcarousel\u002Fdesktop\u002Fbanner_2_21-05-2025.webp","as":"image"},{"rel":"preload","href":"\u002F\u002Fbanners\u002Fcarousel\u002Fdesktop\u002Fbanner_3_21-05-2025.webp","as":"image"},{"rel":"preload","href":"\u002F\u002Fbanners\u002Fcarousel\u002Fdesktop\u002Fbanner_4_21-05-2025.webp","as":"image"}],"script":[{"hid":"google-ads","src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=AW-11127232168","async":true,"defer":true},{"hid":"google-ads-config","innerHTML":"\n            window.dataLayer = window.dataLayer || [];\n            function gtag(){dataLayer.push(arguments);}\n            gtag('js', new Date());\n            gtag('config', 'AW-11127232168');\n          ","type":"text\u002Fjavascript","async":true,"defer":true},{"hid":"gtm","innerHTML":"\n            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            'https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer','GTM-MMB2848K');\n          ","type":"text\u002Fjavascript","async":true,"defer":true},{"hid":"hotjar","innerHTML":"\n            (function(h,o,t,j,a,r){\n              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};\n              h._hjSettings={hjid:4940990,hjsv:6};\n              a=o.getElementsByTagName('head')[0];\n              r=o.createElement('script');r.async=1;\n              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;\n              a.appendChild(r);\n            })(window,document,'https:\u002F\u002Fstatic.hotjar.com\u002Fc\u002Fhotjar-','.js?sv=');\n          ","type":"text\u002Fjavascript","async":true,"defer":true},{"hid":"meta-pixel","innerHTML":"\n            !function(f,b,e,v,n,t,s)\n            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n            n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n            n.queue=[];t=b.createElement(e);t.async=!0;\n            t.src=v;s=b.getElementsByTagName(e)[0];\n            s.parentNode.insertBefore(t,s)}(window, document,'script',\n            'https:\u002F\u002Fconnect.facebook.net\u002Fen_US\u002Ffbevents.js');\n            fbq('init', '899952665295420');\n            fbq('track', 'PageView');\n          ","type":"text\u002Fjavascript","charset":"utf-8"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-MMB2848K')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","innerHTML":"\n            \u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-MMB2848K\"\n            height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"\u003E\u003C\u002Fiframe\u003E\n          "},{"hid":"meta-pixel-noscript","innerHTML":"\n            \u003Cimg height=\"1\" width=\"1\" style=\"display:none\"\n            src=\"https:\u002F\u002Fwww.facebook.com\u002Ftr?id=899952665295420&ev=PageView&noscript=1\"\u002F\u003E\n          "},{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-MMB2848K&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"google-ads-config":["innerHTML"],"gtm":["innerHTML"],"hotjar":["innerHTML"],"gtm-noscript":["innerHTML"],"meta-pixel":["innerHTML"],"meta-pixel-noscript":["innerHTML"],"gtm-script":["innerHTML"]},"style":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_4c48524a === 'function') {
    await nuxt_plugin_plugin_4c48524a(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nuxtplugin41788880_6c9658a9 === 'function') {
    await nuxt_plugin_nuxtplugin41788880_6c9658a9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_41079bc0 === 'function') {
    await nuxt_plugin_vuescrollto_41079bc0(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_c5e9c51e === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_c5e9c51e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_0de4a992 === 'function') {
    await nuxt_plugin_pluginutils_0de4a992(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_7585d966 === 'function') {
    await nuxt_plugin_pluginseo_7585d966(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_453dcb46 === 'function') {
    await nuxt_plugin_pluginrouting_453dcb46(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_1277939c === 'function') {
    await nuxt_plugin_pluginmain_1277939c(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_d0c75642 === 'function') {
    await nuxt_plugin_gtm_d0c75642(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin906f0602_832a181c === 'function') {
    await nuxt_plugin_distplugin906f0602_832a181c(app.context, inject)
  }

  if (typeof nuxt_plugin_image_6df72cc4 === 'function') {
    await nuxt_plugin_image_6df72cc4(app.context, inject)
  }

  if (typeof nuxt_plugin_coreplugin5c3f1c1c_9aa8fe18 === 'function') {
    await nuxt_plugin_coreplugin5c3f1c1c_9aa8fe18(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginse2etesting371dcffc_58d937d2 === 'function') {
    await nuxt_plugin_pluginse2etesting371dcffc_58d937d2(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_bcb82358 === 'function') {
    await nuxt_plugin_deviceplugin_bcb82358(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_0973d6a5 === 'function') {
    await nuxt_plugin_workbox_0973d6a5(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_6cb2a8b8 === 'function') {
    await nuxt_plugin_metaplugin_6cb2a8b8(app.context, inject)
  }

  if (typeof nuxt_plugin_tokenexpired_ca1e20ca === 'function') {
    await nuxt_plugin_tokenexpired_ca1e20ca(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_fcPlugin_5a846bc6 === 'function') {
    await nuxt_plugin_fcPlugin_5a846bc6(app.context, inject)
  }

  if (typeof nuxt_plugin_dompurify_9e093c4a === 'function') {
    await nuxt_plugin_dompurify_9e093c4a(app.context, inject)
  }

  if (typeof nuxt_plugin_storeConfigPlugin_234467e0 === 'function') {
    await nuxt_plugin_storeConfigPlugin_234467e0(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_4a1ca6a6 === 'function') {
    await nuxt_plugin_meta_4a1ca6a6(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
